import { useState, useCallback } from 'react';

interface SortConfig {
  field: string;
  direction: 'ASC' | 'DESC';
}

interface UseTableSortOptions {
  columnMapping: Record<string, string>;
  defaultSort?: SortConfig;
  onPageReset?: () => void;
}

export const useTableSort = ({
  columnMapping,
  defaultSort = { field: 'id', direction: 'ASC' },
  onPageReset
}: UseTableSortOptions) => {
  const [sortConfig, setSortConfig] = useState<SortConfig>(defaultSort);

  const handleSort = useCallback(
    (columnKey: string) => {
      const backendField = columnMapping[columnKey];
      if (!backendField) return;

      setSortConfig((prev) => {
        if (prev.field === backendField) {
          return {
            field: backendField,
            direction: prev.direction === 'ASC' ? 'DESC' : 'ASC'
          };
        }

        const defaultDirection = ['created_at', 'updated_at', 'meeting_date', 'evidence_due_date'].includes(columnKey)
          ? 'DESC'
          : 'ASC';
        return { field: backendField, direction: defaultDirection };
      });

      onPageReset?.();
    },
    [columnMapping, onPageReset]
  );

  const isSorted = useCallback(
    (columnKey: string) => {
      return sortConfig.field === columnMapping[columnKey];
    },
    [sortConfig, columnMapping]
  );

  return {
    sortConfig,
    handleSort,
    isSorted
  };
};
